import { useMemo } from "react";

import { EntityType, EntityTypeSupportingGroups, Group } from "@mapmycustomers/shared/types/entity";
import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import { GroupByType } from "../enum/GroupByType";
import { GroupByEntity } from "../types/GroupByEntity";

const useGroupedEntities = (
  groupByType: GroupByType,
  recordTypes: EntityTypeSupportingGroups[],
  users: User[],
  teams: Team[],
  companyGroups: Group[],
  peopleGroups: Group[],
  dealGroups: Group[]
): GroupByEntity[] =>
  useMemo(() => {
    const groups = [
      ...(recordTypes.includes(EntityType.COMPANY) ? companyGroups : []),
      ...(recordTypes.includes(EntityType.PERSON) ? peopleGroups : []),
      ...(recordTypes.includes(EntityType.DEAL) ? dealGroups : []),
    ];
    return groupByType === GroupByType.USER
      ? users
      : groupByType === GroupByType.TEAM
      ? teams
      : groups;
  }, [companyGroups, dealGroups, groupByType, peopleGroups, recordTypes, teams, users]);

export default useGroupedEntities;
